import { isCustomerUser } from '@order-management/roles';
import useUser from './user';
import useUserHasZspaceInternalAndCustomerRoles from './user-has-zspace-internal-and-customer-roles';

export function useIsMasqueradingCustomerUser() {
  const { user: currentUser } = useUser();
  const hasZspaceInternalAndCustomerRoles =
    useUserHasZspaceInternalAndCustomerRoles();

  return isCustomerUser(currentUser) && hasZspaceInternalAndCustomerRoles;
}

export default useIsMasqueradingCustomerUser;
